import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-776b2b4a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "text-fa"
};
const _hoisted_2 = {
  class: "text-title"
};
const _hoisted_3 = {
  class: "title-tips"
};
const _hoisted_4 = {
  class: "text-cont-fa"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_table = _resolveComponent("a-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString($props.moudleName), 1)]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_table, {
    columns: $data.columns,
    "data-source": $props.caseList,
    rowKey: record => record.key,
    pagination: false
  }, {
    bodyCell: _withCtx(({
      column,
      record,
      index
    }) => [column.dataIndex == 'sortIndex' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(parseInt(index) + 1), 1)) : _createCommentVNode("", true), column.dataIndex == 'action' ? (_openBlock(), _createElementBlock("span", {
      key: 1,
      class: "action",
      onClick: $event => $options.hrefdetail(_ctx.text, record)
    }, "详情", 8, _hoisted_6)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["columns", "data-source", "rowKey"])])]);
}